import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps } from '../IconBase';

export const CastSidepanel = ({
  ref,
  ...props
}: WithRef<SVGSVGElement, Omit<CastProductIconProps, 'variant'>>) => {
  const color = props.color ?? '#fff';
  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 3v18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

CastSidepanel.displayName = 'CastSidepanel';
